import React from 'react';
import './WhatsAppButton.css';

/**
 * Composant WhatsAppButton - Bouton pour contacter via WhatsApp
 * Ouvre WhatsApp avec un message pré-rempli
 */
function WhatsAppButton() {
  // Numéro WhatsApp et message pré-rempli
  const phoneNumber = '+243816795203';
  const message = encodeURIComponent(
    'Bonjour Wote, j\'ai lu vos services sur votre plateforme, je suis intéressé.'
  );
  
  // URL WhatsApp avec message pré-rempli
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=${message}`;

  // Fonction pour ouvrir WhatsApp
  const handleClick = () => {
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button className="whatsapp-button" onClick={handleClick} aria-label="Contacter via WhatsApp">
      <span className="whatsapp-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        </svg>
      </span>
      <span className="whatsapp-text">Écrivez-moi sur WhatsApp</span>
    </button>
  );
}

export default WhatsAppButton;

